import {createBrowserHistory} from 'history';
import {Router, useLocation} from "react-router-dom";
import Routes from "./Routes";
import React, {useEffect} from "react";
import {useSnackbar} from "notistack";

const history = createBrowserHistory();

const ScrollRestoration = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash && !location.pathname.startsWith("/tarif_des_notaires")) {
            return;
        }

        window.scrollTo({top: 0, left: 0, behavior: "auto"});
    }, [location.pathname, location.search, location.hash]);

    return null;
};

function App() {
    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        const handleSlowConnection = (event) => {
            enqueueSnackbar(event.detail, {
                key: "slow-connection",
                variant: "error",
                preventDuplicate: true,
            });
        };

        window.addEventListener("api:slow-connection", handleSlowConnection);
        return () => {
            window.removeEventListener("api:slow-connection", handleSlowConnection);
        };
    }, [enqueueSnackbar]);

    return (
        <>
            <Router history={history}>
                <ScrollRestoration/>
                <Routes/>
            </Router>
        </>
    );
}

export default App;
